<script setup>
// NOTICE: KAPTION-INTEGRATION — security-center.UI.3: label + value + copy button
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { copyTextToClipboard } from 'shared/helpers/clipboard';

const props = defineProps({
  label: { type: String, required: true },
  value: { type: String, required: true },
});

const { t } = useI18n();
const copied = ref(false);

const copy = async () => {
  await copyTextToClipboard(props.value);
  copied.value = true;
  setTimeout(() => {
    copied.value = false;
  }, 1500);
};
</script>

<template>
  <div class="flex items-center gap-3 min-w-0">
    <span class="w-32 text-sm shrink-0 text-n-slate-11">{{ label }}</span>
    <code
      class="flex-1 min-w-0 px-2 py-1 text-[13px] truncate rounded-md bg-n-alpha-2 text-n-slate-12"
      :title="value"
      >{{ value }}</code
    >
    <button
      type="button"
      class="flex items-center justify-center rounded-md size-7 shrink-0 text-n-slate-11 hover:bg-n-alpha-2"
      :aria-label="t('KAPTION_SECURITY.COMMON.COPY', { label })"
      @click="copy"
    >
      <span
        class="size-4"
        :class="copied ? 'i-lucide-check text-n-teal-11' : 'i-lucide-copy'"
        aria-hidden="true"
      />
    </button>
  </div>
</template>
